import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";

import Modal from "react-modal";
import moment from "moment";
import { toast } from "react-toastify";

const PackagingLabelingForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "15%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "800px",
      maxHeight: "450px",
      height: "100%",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const frmRef = useRef({});
  const labelingRef = useRef({});

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const [loading, setLoading] = useState(false);

  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const [employeeData, setEmployeeData] = useState();

  const packagingRef = useRef({});
  const [packagingDetails, setPackagingDetails] = useState([]);
  const [packagingClose, setPackagingClose] = useState(false);

  const [employeelist, setEmployeelist] = useState(null);
  const [assignEmployeeId, setAssignEmployeeId] = useState();

  const [labelingDetails, setLabelDetails] = useState([]);
  const [labelingClose, setLabelingClose] = useState(false);
  const [varietyId, setVarietyId] = useState();
  const [productData, setProductData] = useState([]);
  const [productMainData, setproductMainData] = useState([]);
  const [PackagingVarietyProduct, setPackagingVarietyProduct] = useState([]);
  const [packagingProductId, setpackagingProductId] = useState();
  const [packagingProductUnitId, setpackagingProductUnitId] = useState();
  const [lableCount, setlableCount] = useState();
  const [otherProductData, setotherProductData] = useState([]);
  const [otherProductId, setotherProductId] = useState();
  const [inputProductId, setinputProductId] = useState();
  const [inputProductUnitId, setinputProductUnitId] = useState();
  const [totalInputProductCost, setTotalInputProductCost] = useState(0);
  const [productId, setProductId] = useState();
  const [lotitem, setlotitem] = useState();
  const [lotData, setlotData] = useState([]);
  const [weightUnits, setWeightUnits] = useState([]);
  const [grossWeightId, setgrossWeightId] = useState();
  const [lotNo, setlotNo] = useState();
  const [totalLotAmount, setTotalLotAmount] = useState();

  const [batchId, setbatchId] = useState();
  const [farmerNo, setfarmerNo] = useState();
  const [packItemCode, setpackItemCode] = useState();
  const [packingTime, setpackingTime] = useState();
  const [grossWeight, setgrossWeight] = useState();
  const [netWeight, setnetWeight] = useState();
  const [grossNetweightUnit, setgrossNetweightUnit] = useState();

  const [pricePerUnit, setpricePerUnit] = useState();
  const [shelfLifeDays, setshelfLifeDays] = useState();
  const [labelIdSequence, setlabelIdSequence] = useState();
  const [packinghouseCode, setpackinghouseCode] = useState();
  const [productionUnitCode, setproductionUnitCode] = useState();

  const [availableAmount, setavailableAmount] = useState();
  const [unitId, setunitId] = useState();
  const [inputUnit, setinputUnit] = useState("(No)");

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
        
      },
      (data) => {
       
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getunits } = useHttp();

  useEffect(() => {
    getunits(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
        
          const weightUnits =
            res && res.filter((item) => item.unitTypeName == "Weight");
          setWeightUnits(weightUnits);
        }
      }
    );
  }, [getunits]);

  const { sendRequest: getLot } = useHttp();

  useEffect(() => {
    const data = {
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      process: "PKG",
    };
    getLot(
      {
        url: "/api/getStockLotForPackhouseProcess/",
        method: "POST",
        body: data,
      },
      (data) => {
       

        setlotData(data);
      }
    );
  }, [getLot]);

  const handleLotIdChange = (e) => {
   
    const id = e.target.value;
    const data = lotData && lotData.filter((item) => item.stockId == id);
    const vId = data[0].varietyId;
   

    setlotNo(data[0].lotNo);
    setbatchId(data[0].batchNo);

    
    var farmerDetail = data[0].farmerDetail;
    setfarmerNo(farmerDetail && farmerDetail.farmerName);


    setinputProductId(data[0].productId);
    setVarietyId(data[0].varietyId || "");
   
    var packproduct = productMainData.filter(
      (item) => item.varietyId == vId && item.packagingTypeId > 0
    );
  //  console.log("packproduct", packproduct);
    setPackagingVarietyProduct(packproduct);
    frmRef.current.totalQuantity.value = data[0].productQuantityBal;
    frmRef.current.totalInputQuantity.value = data[0].productQuantityBal;
    setTotalInputProductCost(data[0].productAmountBal);
    setTotalLotAmount(data[0].productAmountBal);
    setinputProductUnitId(data[0].unitId);
   
  };

  const { sendRequest: getproduct } = useHttp();

  const getProductDetail = () => {
    getproduct(
      {
        url: "/api/product/",
      },
      (res) => {
        if (res) {
        

          setproductMainData(res);
          var Otherinputproduct = res.filter(
            (item) => (item.varietyId || 0) == 0
          );
         
          setotherProductData(Otherinputproduct);
          var inputproduct = res.filter((item) => item.varietyId > 0);
          setProductData(inputproduct);
        }
      }
    );
  };

  useEffect(() => {
    getProductDetail();
  }, [getproduct]);

  const { sendRequest: postPackingLabeling } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    setLoading(true);

    var labeling = {
      lotNo: lotNo,
      batchNo: batchId,
      farmerName: farmerNo,
      packItemCode: packItemCode,
      packingTime: packingTime,
      grossWeight: grossWeight,
      netWeight: netWeight,
      grossNetweightUnit: grossNetweightUnit,
      pricePerUnit: pricePerUnit,
      shelfLifeDays: shelfLifeDays,
      packinghouseCode: packinghouseCode,
      productionUnitCode: productionUnitCode,
      labelCount: frmRef.current.ProductQuantity.value,
      labelIdSequence: labelIdSequence,
      nettingCount: frmRef.current.nettingCount.value,
    };
    var packagingsquence = [];

    var i = 0;
    var productCost = 0;
    var outputproductcost = 0;
 
    var productQuantity = parseFloat(frmRef.current.ProductQuantity.value);
    var totalInputQuantity = parseFloat(
      frmRef.current.totalInputQuantity.value
    );
    var totalQuantity = parseFloat(frmRef.current.totalQuantity.value);
    var productCost = (totalLotAmount / totalQuantity) * totalInputQuantity;
    var amountPerBox = 0;
    
    var count = parseInt(frmRef.current.ProductQuantity.value);
    amountPerBox = productCost / count;
    outputproductcost = productCost;
    do {
      packagingsquence = packagingsquence.concat({
        linesrno: i + 1,
        packedId: parseInt(labelIdSequence) + i,
        ispalltized: false,
        grossWeightPerCarton: frmRef.current.cartonGrossWeight.value,
        netWeightPerCarton: frmRef.current.netWeight.value,
        grossWeightId: grossWeightId,
        productCost: amountPerBox,
      });

      i++;
    } while (count > i);

    var labeling = [];
    const data = {
      plmDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      supervisorEmployeeId: assignEmployeeId,
      inputProductId: inputProductId,
      stockId: frmRef.current.lot_id.value,
      totalInputQuantity: frmRef.current.totalInputQuantity.value,
      totalInputCost: productCost,
      outputproductcost: outputproductcost,
      unitId: inputProductUnitId,
      packagingProductId: packagingProductId,
      packagingProductUnitId: packagingProductUnitId,
      productQuantity: frmRef.current.ProductQuantity.value,
      nettingCount: frmRef.current.nettingCount.value,
      pricePerUnit: pricePerUnit,
      productionUnitCode: productionUnitCode,
      packinghouseCode: packinghouseCode,
      grossWeightPerCarton: frmRef.current.cartonGrossWeight.value,
      netWeightPerCarton: frmRef.current.netWeight.value,
      labelIdSequence: labelIdSequence,
      shelfLifeDays: shelfLifeDays,
      perCartonWeightUnitId: grossWeightId,
      productDetail: productDetails,
      boxDetail: packagingsquence,
      labeling: labeling,
      remark: frmRef.current.remark.value,
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: dateString,
      orgId: localStorage.getItem("orgId"),
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };
    if (props.update) {
      data["plmId"] = props.update.plmId;
    }
   
    postPackingLabeling(
      {
        url: "/api/packagingLabelingMarking/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
       
        props.addForm(false);
        toast.success("Packaging And Labeling data added");
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };
  useEffect(() => {
    if (props.update) {
      frmRef.current.date.value = moment(props.update.plmDate).format(
        "YYYY-MM-DD"
      );
      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      frmRef.current.lot_id.value = props.update.lotId;
      frmRef.current.grade.value = props.update.grade;
      frmRef.current.batch_id.value = props.update.batchId;
      frmRef.current.total_input_weight.value = props.update.totalInputQuantity;
      frmRef.current.unit.value = props.update.unit;
      setPackagingDetails(props.update.packaging);
      setLabelDetails(props.update.labeling);
      setProductDetails(props.update.packaging[0].productDetails);
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);

  const submitProduct = (e) => {
    e.preventDefault();
    var itemlist = otherProductData.filter(
      (item) => item.productId == otherProductId
    );
  
    var selectedItem = itemlist[0];
    var productId1 = otherProductId;
    var itemId = selectedItem.itemId;
    var productName = selectedItem.productName;
    var productSubType = productRef.current.productSubType.value;
    var productType = productRef.current.productType.value;
    var availableQuantity = productRef.current.availableQuantity.value;
    var unit = productRef.current.productUnit.value;
    var unitId1 = unitId;
    var availableAmount1 = availableAmount;
    var itemQuantity = productRef.current.itemQuantity.value;

    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,
        productId: productId1,
        itemId: itemId,
        productName: productName,
        productSubType: productSubType,
        productType: productType,
        availableQuantity: availableQuantity,
        unit: unit,
        unitId: unitId1,
        availableAmount1: availableAmount1,
        itemQuantity: itemQuantity,
        itemQuantityBal: itemQuantity,
        productCost: 0,
        remark: frmRef.current.remark.value,
        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
  
      },
    ]);

    setProductId(0);

    productRef.current.productSubType.value = "";
    productRef.current.productType.value = "";
    productRef.current.availableQuantity.value = "";
    productRef.current.productUnit.value = "";
    setunitId(0);
    setavailableAmount(0);
    productRef.current.itemQuantity.value = "0";
    
  };

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const { sendRequest: getAvailableStock } = useHttp();

  const loadStockData = (id) => {
    productRef.current.productSubType.value = "";
    productRef.current.productType.value = "";
   
    var itemlist = otherProductData.filter((item) => item.productId == id);
    var selectedItem = itemlist[0];

  

    productRef.current.productSubType.value = selectedItem.productSubTypeName;
    productRef.current.productType.value = selectedItem.productTypeName;
    const data = {
      warehouseId: localStorage.getItem("warehouseId"),
      productId: id,
    };

    getAvailableStock(
      {
        url: "/api/getAvailableStock/",
        method: "POST",
        body: data,
      },
      (myres) => {

        var res=myres.data


        productRef.current.availableQuantity.value = res.availableQty;
        productRef.current.productUnit.value = res.unitName;
        productRef.current.unitId.value = res.unitId;
        productRef.current.availableAmount.value = res.availableAmount;
        setavailableAmount(res.availableAmount);
        setunitId(res.unitId);
      }
    );
  };

  const submitPackaging = (e) => {
    e.preventDefault();
    setPackagingDetails([
      {
        productDetails: productDetails,
        packingTime: packagingRef.current.packing_time.value,
        nettingCount: packagingRef.current.item_count.value,
        packedItemId: packagingRef.current.packed_item.value,
        cartonGrossWeight: packagingRef.current.carton_gross_weight.value,
        grossWeightUnit: packagingRef.current.gross_weight_unit.value,
        CartonNetWeight: packagingRef.current.net_weight.value,
        netWeightUnit: packagingRef.current.net_weight_unit.value,
        isSave: true,
      },
    ]);

 
    setPackagingClose(false);
  };

  const submitLabeling = (e) => {
    e.preventDefault();
    setLabelDetails((x) => [
      ...x,
      {
        srno:
          labelingDetails.length > 0
            ? labelingDetails[labelingDetails.length - 1].srno + 1
            : 1,

        lotId: labelingRef.current.lotId.value,
        batchId: labelingRef.current.batch_id.value,
        farmerId: labelingRef.current.farmer_id.value,
        packedItemId: labelingRef.current.packed_item_id.value,
        labelCount: labelingRef.current.label_count.value,
        labelIdSequence: labelingRef.current.label_id_sequence.value,
        packingTime: labelingRef.current.packing_time.value,
        shelfLifeDays: labelingRef.current.shelf_life.value,
        cartonGrossWeight: labelingRef.current.gross_weight.value,
        netWeight: labelingRef.current.gross_weight.value,
        unit: labelingRef.current.unit.value,
        pricePerUnit: labelingRef.current.price_per_unit.value,
        productionUnitCode: labelingRef.current.production_code.value,
        packinghouseCode: labelingRef.current.packinghouseCode.value,
      },
    ]);

    
  };
  const handleLabelingDelete = (index, e) => {
    setLabelDetails(labelingDetails.filter((v, i) => i !== index));
  };
  return (
    <>
      {labelingClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Labeling Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setLabelingClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"lotId"}>Lot Id</label>
              <input
                type={"input"}
                id={"lotId"}
                readOnly
                defaultValue={lotNo}
                ref={(el) => (labelingRef.current["lotId"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"batch_id"}>Batch Id</label>
              <input
                type={"input"}
                id={"batch_id"}
                readOnly
                defaultValue={batchId}
                ref={(el) => (labelingRef.current["batch_id"] = el)}
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"farmer_id"}>Farmer id</label>
              <input
                type={"input"}
                id={"farmer_id"}
                readOnly
                defaultValue={farmerNo}
                ref={(el) => (labelingRef.current["farmer_id"] = el)}
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"packed_item_id"}>Packed item id</label>
              <input
                type={"input"}
                id={"packed_item_id"}
                readOnly
                defaultValue={packItemCode}
                ref={(el) => (labelingRef.current["packed_item_id"] = el)}
                className="form-control"
              />
            </div>
          </div>

          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"packingTime"}>Packing Time</label>
              <input
                type={"time"}
                id={"timeStamp"}
                readOnly
                defaultValue={packingTime}
                ref={(el) => (labelingRef.current["timeStamp"] = el)}
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"productionUnitCode"}>Production UnitCode</label>
              <input
                type={"number"}
                id={"productionUnitCode"}
                required
                ref={(el) => (labelingRef.current["productionUnitCode"] = el)}
                onChange={(e) => {
                  setproductionUnitCode(e.target.value);
                }}
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"packinghouseCode"}>Packinghouse Code</label>
              <input
                type={"number"}
                id={"packinghouseCode"}
                required
                onChange={(e) => {
                  setpackinghouseCode(e.target.value);
                }}
                ref={(el) => (labelingRef.current["packinghouseCode"] = el)}
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"label_count"}>Label count</label>
              <input
                type={"number"}
                id={"label_count"}
                readOnly
                defaultValue={lableCount}
                ref={(el) => (labelingRef.current["label_count"] = el)}
                className="form-control"
              />
            </div>
          </div>

          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"label_id_sequence"}>Label id Sequence</label>
              <input
                type={"number"}
                id={"label_id_sequence"}
                required
                onChange={(e) => {
                  setlabelIdSequence(e.target.value);
                }}
                ref={(el) => (labelingRef.current["label_id_sequence"] = el)}
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"shelfLifeDays"}>Shelf Life Days</label>
              <input
                type={"number"}
                id={"shelfLifeDays"}
                required
                onChange={(e) => {
                  setshelfLifeDays(e.target.value);
                }}
                ref={(el) => (labelingRef.current["shelfLifeDays"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"price_per_unit"}>Price per Unit(Rs)</label>
              <input
                type={"number"}
                id={"pricePerUnit"}
                required
                onChange={(e) => {
                  setpricePerUnit(e.target.value);
                }}
                ref={(el) => (labelingRef.current["pricePerUnit"] = el)}
                className="form-control"
              />
            </div>
          </div>

          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"gross_weight"}>Carton Gross Weight</label>
              <input
                type={"number"}
                id={"gross_weight"}
                required
                defaultValue={grossWeight}
                ref={(el) => (labelingRef.current["gross_weight"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"net_weight"}>Net Weight </label>
              <input
                type={"number"}
                id={"net_weight"}
                required
                defaultValue={netWeight}
                ref={(el) => (labelingRef.current["net_weight"] = el)}
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"unit"}>Unit</label>

              <input
                type={"number"}
                id={"grossWeightId"}
                required
                readOnly
                defaultValue={grossNetweightUnit}
                ref={(el) => (labelingRef.current["grossWeightId"] = el)}
                className="form-control"
              />
            </div>
          </div>

          <div className="text-center">
            <div className="mt-3">
              <button
                className="btn btn-sm btn-primary"
                onClick={() => {
                  labelingDetails.map((x) => (x["isSave"] = true));
                  setLabelingClose(false);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </Modal>
      )}
      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div>
            <div className="">
              <h3 className="card-title">Product Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setClose(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-3">
                {" "}
                <label htmlFor={"productId"}> Item Id</label>
                <select
                  id="productId"
                  className="form-control dropdowns"
                  ref={(el) => (frmRef.current["productId"] = el)}
                  value={otherProductId}
                  onChange={(e) => {
                    setotherProductId(e.target.value);

                    loadStockData(e.target.value);
                  }}
                >
                  <option>--Select Product Name--</option>
                  {otherProductData &&
                    otherProductData.map((x) => (
                      <option
                        key={x.productId}
                        product-id={x.productId}
                        value={x.productId}
                      >
                        {x.productName + "(" + x.itemId + ")"}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                {" "}
                <label htmlFor={"productId"}> Product SubType </label>{" "}
                <input
                  type={"input"}
                  id={"itemType"}
                  readOnly
                  ref={(el) => (productRef.current["productSubType"] = el)}
                  className="form-control"
                />{" "}
              </div>
              <div className="col-md-3">
                <label htmlFor={"productId"}> Product Type </label>{" "}
                <input
                  type={"input"}
                  id={"productType"}
                  readOnly
                  ref={(el) => (productRef.current["productType"] = el)}
                  className="form-control"
                />{" "}
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-3">
                {" "}
                <label htmlFor={"Available"}> Available Quantity</label>
                <input
                  type={"input"}
                  id={"itemType"}
                  readOnly
                  ref={(el) => (productRef.current["availableQuantity"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                {" "}
                <label htmlFor={"unit"}> Unit</label>
                <input
                  type={"input"}
                  id={"itemType"}
                  readOnly
                  ref={(el) => (productRef.current["productUnit"] = el)}
                  className="form-control"
                />
                <input
                  name="hiddenInput"
                  value=""
                  type="hidden"
                  ref={(el) => (productRef.current["unitId"] = el)}
                />
                <input
                  name="hiddenInput"
                  value=""
                  type="hidden"
                  ref={(el) => (productRef.current["availableAmount"] = el)}
                />
              </div>
              <div className="col-md-3">
                <label htmlFor={"unit"}> Item Quantity</label>
                <input
                  type={"input"}
                  id={"itemType"}
                  ref={(el) => (productRef.current["itemQuantity"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                <br />{" "}
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={submitProduct}
                >
                  +
                </button>{" "}
              </div>
            </div>
          </div>

          <hr />

          <table className="table table-bordered table-sm">
            <thead>
              <tr className="tableheaderrowview">
                <th>Sr. No</th>
                <th>Item Id</th>
                <th>Product Name</th>
                <th>Item SubType</th>
                <th>Item Type</th>
                <th>Available Quantity</th>
                <th>Unit</th>
                <th>Item Quantity</th>
                <th>Unit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {productDetails &&
                productDetails.map((itm, i) => {
                  return (
                    <tr key={i.srno}>
                      <td>{itm.srno}</td>
                      <td>{itm.itemId}</td>
                      <td>{itm.productName}</td>
                      <td>{itm.productSubType}</td>
                      <td>{itm.productType}</td>
                      <td>{itm.availableQuantity}</td>
                      <td>{itm.unit}</td>
                      <td>{itm.itemQuantity}</td>
                      <td>{itm.unit}</td>

                      <td>
                        <button
                          className="btn"
                          onClick={(e) => handleDelete(i, e)}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                productDetails.map((x) => (x["isSave"] = true));
                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      {packagingClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div>
            <div className="row mb-2">
              <div className="col-md-3">
                <label htmlFor={"packed_item"}>Packed item id Sequence </label>
                <input
                  type={"input"}
                  id={"packed_item"}
                  required
                  ref={(el) => (packagingRef.current["packed_item"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-3"></div>
              <div className="col-md-3">
                <label htmlFor={"gross_weight_unit"}>Unit</label>
                <select
                  id="gross_weight_unit"
                  className="drop-prod form-control"
                  ref={(el) => (packagingRef.current["gross_weight_unit"] = el)}
                >
                  <option value="Number">Number</option>
                  <option value="Miligram">Miligram</option>
                  <option value="Gram">Gram</option>
                  <option value="Kilogram">Kilogram</option>
                  <option value="Milliliter">Milliliter</option>
                  <option value="Liter">Liter</option>
                  <option value="Tons">Tons</option>
                </select>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-3"></div>
              <div className="col-md-3">
                <label htmlFor={"net_weight_unit"}>Unit</label>
                <select
                  id="diseased_unit"
                  className="form-control dropdowns"
                  value={grossWeightId}
                  ref={(el) => (frmRef.current["grossWeightId"] = el)}
                >
                  <option value="">Select</option>
                  {weightUnits &&
                    weightUnits.map((x) => (
                      <option value={x.unitId}>{x.unitAbbreviation}</option>
                    ))}
                </select>
              </div>
            </div>

            <div className="row mb-2">
              <button
                className="btn btn-sm btn-"
                style={{ width: "auto", marginLeft: "120px" }}
                onClick={submitPackaging}
              >
                Save
              </button>
            </div>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">&nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Packaging Labeling Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"emp_id"}>{"Packhouse Employee"}</label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={assignEmployeeId}
                        required
                        onChange={(e) => {
                          setAssignEmployeeId(e.target.value);
                        }}
                      >
                        <option value="">--Select Employee--</option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"packing_time"}>Packing Time</label>

                      <input
                        type={"time"}
                        id={"packingTime"}
                        required
                        ref={(el) => (frmRef.current["packingTime"] = el)}
                        className="form-control"
                        defaultValue={getCurrentTime()}
                        onChange={(e) => {
                          // //console.log(e.target.value);
                          setpackingTime(e.target.value);
                          // labelingRef.current.timeStamp.value=e.target.value;
                        }}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"lot_id"}>{"Lot Id "}</label>
                      <select
                        id="lot_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["lot_id"] = el)}
                        onChange={handleLotIdChange}
                      >
                        <option>select</option>
                        {lotData &&
                          lotData.map((x) => (
                            <option value={x.stockId}>
                              {x.lotNo + "(" + x.productName + ")"}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"totalw"}>
                        {"Total Quantity" + inputUnit}
                      </label>
                      <input
                        type={"text"}
                        id={"totalWeight"}
                        required
                        ref={(el) => (frmRef.current["totalQuantity"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"totalQuantity"}>
                        {"Total input Quantity"}
                      </label>
                      <input
                        type={"text"}
                        id={"totalInputQuantity"}
                        required
                        ref={(el) =>
                          (frmRef.current["totalInputQuantity"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"packagingType"}>
                        {"Packaging Product"}
                      </label>

                      <select
                        id="productId"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["productId"] = el)}
                        value={packagingProductId}
                        onChange={(e) => {
                          setpackagingProductId(e.target.value);

                          var itemlist = PackagingVarietyProduct.filter(
                            (item) => item.productId == e.target.value
                          );
                          var selectedItem = itemlist[0];
                          setpackItemCode(itemlist[0].itemId);
                          //loadStockData(e.target.value);
                        }}
                      >
                        <option>--Select Product Name--</option>
                        {PackagingVarietyProduct &&
                          PackagingVarietyProduct.map((x) => (
                            <option
                              key={x.productId}
                              product-id={x.productId}
                              value={x.productId}
                            >
                              {x.productName + "(" + x.itemId + ")"}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"totalQuantity"}>
                        {"Product Quantity(No)"}
                      </label>
                      <input
                        type={"text"}
                        id={"ProductQuantity"}
                        required
                        onChange={(e) => {
                          setlableCount(e.target.value);
                        }}
                        ref={(el) => (frmRef.current["ProductQuantity"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        className="btn btn-sm btn-success"
                        formNoValidate="True"
                        onClick={(e) => {
                          e.preventDefault(false);
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter((x) => x.isSave)
                            );
                          setClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"cartonGrossWeight"}>
                        Gross Weight/Carton
                      </label>
                      <input
                        type={"input"}
                        className="form-control"
                        id={"cartonGrossWeight"}
                        required
                        onChange={(e) => {
                          setgrossWeight(e.target.value);
                        }}
                        ref={(el) => (frmRef.current["cartonGrossWeight"] = el)}
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"netWeight"}>Net Weight / Carton</label>
                      <input
                        type={"input"}
                        id={"netWeight"}
                        required
                        onChange={(e) => {
                          setnetWeight(e.target.value);
                        }}
                        ref={(el) => (frmRef.current["netWeight"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Unit"}>{"Unit"}</label>

                      <select
                        id="diseased_unit"
                        className="form-control dropdowns"
                        value={grossWeightId}
                        ref={(el) => (frmRef.current["unit"] = el)}
                        onChange={(e) => {
                          setgrossWeightId(e.target.value);
                          var itemlist = weightUnits.filter(
                            (item) => item.productId == e.target.value
                          );
                          var selectedItem = itemlist[0];
                          setgrossNetweightUnit(
                            selectedItem && selectedItem.unitId
                          );
                        }}
                      >
                        <option value="">Select</option>
                        {weightUnits &&
                          weightUnits.map((x) => (
                            <option
                              key={x.unitId}
                              product-id={x.unitId}
                              value={x.unitId}
                            >
                              {x.unitAbbreviation}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"item_count"}>Netting Count</label>
                      <input
                        type={"input"}
                        id={"item_count"}
                        required
                        ref={(el) => (frmRef.current["nettingCount"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"labeling"}>{"Labeling"}</label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        className="btn btn-sm btn-info"
                        formNoValidate="True"
                        onClick={(e) => {
                          e.preventDefault(false);
                          setLabelDetails((items) =>
                            items.filter((x) => x.isSave)
                          );
                          setLabelingClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        required
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PackagingLabelingForm;
